export default function Header() {
    return (<header>
    	<h1><a href="./">QuickR</a></h1>
    	<p className="tagline">Generate free QR codes with QuickR™</p>
    </header>);
}
